import { render, staticRenderFns } from "./GoalSelection.vue?vue&type=template&id=0496f6c7&scoped=true"
import script from "./GoalSelection.vue?vue&type=script&lang=js"
export * from "./GoalSelection.vue?vue&type=script&lang=js"
import style0 from "./GoalSelection.vue?vue&type=style&index=0&id=0496f6c7&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0496f6c7",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0496f6c7')) {
      api.createRecord('0496f6c7', component.options)
    } else {
      api.reload('0496f6c7', component.options)
    }
    module.hot.accept("./GoalSelection.vue?vue&type=template&id=0496f6c7&scoped=true", function () {
      api.rerender('0496f6c7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/provider/referral-management/search/components/GoalSelection.vue"
export default component.exports